import {
  ControlPeriod,
  ControlPeriodType,
} from "@enos-monorepo/lib/types/FoodManagementTypes";
import axios from "axios";

const ControlPeriodsArray: ControlPeriod[] = [
  {
    description: ControlPeriodType.weekly,
    durationInDays: 7,
  },
  {
    description: ControlPeriodType.twoWeekly,
    durationInDays: 14,
  },
  {
    description: ControlPeriodType.monthly,
    durationInDays: 31,
  },
  {
    description: ControlPeriodType.yearly,
    durationInDays: 365,
  },
];

export const ControlPeriods = ControlPeriodsArray.reduce(
  (acc, period) => ({
    ...acc,
    [period.description]: period,
  }),
  {} as Record<ControlPeriodType, ControlPeriod>,
);

export async function getAllControlPeriods() {
  return axios
    .get<ControlPeriod[]>(`/FoodControlPeriods/getallfoodcontrolperiods`)
    .then((res) => res.data);
}

export async function getControlPeriodByLocation(payload: {
  companyId: string;
  companyLocationId: string;
}) {
  return axios
    .get<ControlPeriod>(`/FoodControlPeriods/getfoodcontrolperiodbylocation`, {
      params: payload,
    })
    .then((res) => res.data);
}

export async function getAllControlPeriodsByLocations(
  payload: {
    companyId: string;
    companyLocationId: string;
  }[],
) {
  return await Promise.all(
    payload.map((location) =>
      axios
        .get(`/FoodControlPeriods/getfoodcontrolperiodbylocation`, {
          params: location,
        })
        .then((res) => {
          return { ...res.data, locationId: location.companyLocationId };
        }),
    ),
  );
}

export async function getAllControlPointTypes() {
  return axios
    .get<
      {
        id: string;
        durationInDays: number;
        description: string;
      }[]
    >(`/FoodControlPeriods/getallfoodcontrolperiods`, {})
    .then((res) => res.data);
}

export async function updateFoodControlPointPeriod(payload: {
  companyId: string;
  companyLocationId: string;
  controlPeriodId: string;
}) {
  return axios
    .put(`/FoodControlPoints/updateperiodtofoodcontrolpoint`, payload)
    .then((res) => res.data);
}
